import { useContext } from "react";
import { Navigate, Outlet, Route, Routes as Router } from "react-router-dom";
import { AuthContext } from "../auth/authContext";
import Home from "../pages/home";
import { isValidToken } from "../auth/utils";
import MainLayout from "../mainLayout";
import LogInPage from "../pages/LogInPage";
import { PATH_PRIVATE } from "./paths";
import { elements } from "./elements";
type Props = {};

const PrivateRoutes = () => {
  const { authenticated, setAuthenticated } = useContext(AuthContext);

  if (!isValidToken()) {
    setAuthenticated(false);
  } else {
    setAuthenticated(true);
  }

  if (!authenticated) return <Navigate to="./login" replace={true} />;

  return (
    <MainLayout>
      <Outlet />
    </MainLayout>
  );
};

const Routes = (props: Props) => {
  return (
    <Router>
      <Route path="/login" element={<LogInPage />} />
      <Route element={<PrivateRoutes />}>
        {elements.map((element) => (
          <Route path={element.Path} element={element.Component} />
        ))}
      </Route>
    </Router>
  );
};

export default Routes;
